import Descriptions from './Descriptions';
export default Descriptions;
